import { ClaimStatusEnum } from 'corso-types';
import { useIsCorsoCxAgent } from '~/hooks/useIsCorsoAdmin';
import { useShippingClaim } from '../ShippingClaimReviewProvider';

/** Shipping claims are resolved by Corso CX, not by the merchant. */
export function useCanEditShippingClaim() {
  const { resolvedOn, hasBeenInvoiced, status } = useShippingClaim();
  const isCorsoCxAgent = useIsCorsoCxAgent();

  // ? a resolved, denied, or invoiced claim can not be edited at all
  if (resolvedOn || hasBeenInvoiced || status === ClaimStatusEnum.closedDenied)
    return false;

  return isCorsoCxAgent;
}

/** Only a claim closed by hand (resolved or denied) can be restored; finalized claims already paid out. */
export function useCanRestoreShippingClaim() {
  const { status, hasBeenInvoiced } = useShippingClaim();
  const isCorsoCxAgent = useIsCorsoCxAgent();

  if (hasBeenInvoiced) return false;

  return (
    isCorsoCxAgent &&
    (status === ClaimStatusEnum.closedResolved ||
      status === ClaimStatusEnum.closedDenied)
  );
}
